import { module } from 'modujs';
import { html } from '../utils/environment';
import gsap, { ScrollTrigger } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger);

const CLASS_MODAL = 'has-newsletter-open';

export default class Modal extends module {
    constructor(m) {
        super(m);

        this.$el = this.el

        this.hasBeenClosed = false;

        this.newsletter = ScrollTrigger.create({
            trigger: '.c-category_slider',
            scrub: true,
            start: "bottom 50%",
            onEnter: () => {
                this.open()
            }
        })

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    open() {
        html.classList.add(CLASS_MODAL);
    }

    close() {
        this.hasBeenClosed = true;
        this.newsletter.kill()
        html.classList.remove(CLASS_MODAL);
    }
}
